import React, { useMemo, useState } from "react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import ProjectCard from "@/components/ProjectCard";
import CTABand from "@/components/CTABand";
import { allProjects, FILTER_OPTIONS } from "@/data/projects";

const Developments = () => {
  const [filter, setFilter] = useState("All");
  const filtered = useMemo(
    () => (filter === "All" ? allProjects : allProjects.filter((p) => p.categories.includes(filter))),
    [filter]
  );

  return (
    <div data-testid="developments-page">
      <SEO
        title="Selected Developments Across the UAE"
        description="A filterable collection of selected UAE developments — branded residences, waterfront and beachfront addresses, commercial and family communities across Dubai, Abu Dhabi and Ras Al Khaimah & Al Marjan Island."
        path="/developments"
        keywords="Palm Jumeirah villas for sale, Dubai Marina luxury apartments, Al Marjan Island property investment, off-plan luxury property Dubai"
      />
      <PageHero
        eyebrow="Selected Developments"
        title="The developments we stand behind"
        intro="Filter by emirate, lifestyle character or investment profile. Every development listed here has passed the ACRE curation standard."
        testid="developments-hero"
      />

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex flex-wrap gap-3 mb-12" data-testid="developments-filters">
            {FILTER_OPTIONS.map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                data-testid={`filter-${f.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className={`text-[11px] uppercase tracking-[0.15em] px-5 py-2.5 rounded-full border transition-all duration-300 ${
                  filter === f
                    ? "border-[#C5A880] text-[#0B0C10] bg-gradient-to-r from-[#E6CA65] to-[#C5A880] font-semibold"
                    : "border-[rgba(197,168,128,0.25)] text-[#9DA3AE] hover:border-[#C5A880] hover:text-[#E6CA65]"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
          <p className="text-xs text-[#9DA3AE] mb-8 font-light" data-testid="developments-count">
            {filtered.length} development{filtered.length === 1 ? "" : "s"} · {filter}
          </p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="developments-grid">
            {filtered.map((p, i) => (
              <Reveal key={p.slug} delay={(i % 3) * 0.06}>
                <ProjectCard project={p} basePath="/developments" ctaLabel="Request Details & Availability" index={i} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CTABand testid="developments-cta" />
    </div>
  );
};

export default Developments;
